import { render, staticRenderFns } from "./BorderConfiguration.vue?vue&type=template&id=839c71ce&"
import script from "./BorderConfiguration.vue?vue&type=script&lang=js&"
export * from "./BorderConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports